import { Tabs, TabsList, TabsTrigger } from "../../components/ui/tabs";
import PlaybookAdminModule from "./PlaybookAdminModule";
import KitDocumentiPanel from "./KitDocumentiPanel";

export default function CommercialKitModule({ servizio, tab = "playbook", onTabChange }) {
  const current = tab === "documenti" ? "documenti" : "playbook";
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Kit commerciale {servizio}</h1>
        <p className="mt-1 text-sm text-slate-500">Materiali operativi dedicati al servizio {servizio}.</p>
      </div>
      <Tabs value={current} onValueChange={(next) => onTabChange?.(next)}>
        <TabsList><TabsTrigger value="playbook">Playbook</TabsTrigger><TabsTrigger value="documenti">Documenti commerciali</TabsTrigger></TabsList>
      </Tabs>
      {current === "playbook" ? <PlaybookAdminModule servizio={servizio} /> : <KitDocumentiPanel servizio={servizio} />}
    </div>
  );
}
